<template>
  <div>
    <van-nav-bar  @click-left="onClickLeft"
      title="收银台"
      left-arrow/>
      <van-cell-group>
        <van-cell title="订单编号" :value="order.orderCode"/>
          <van-cell title="应付金额">
            <span class="red strong">￥{{order.totalPriceCount}}</span>
          </van-cell>
      </van-cell-group>
    <van-button class="footer" type="danger" size="large" @click="wxPay">立即支付</van-button>
  </div>
</template>

<script>
import {Button, Cell, CellGroup, NavBar, Radio, RadioGroup, Toast} from 'vant'
import {Indicator} from "mint-ui";

history.pushState(null,null,"/cpis/");

export default {
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Toast.name]: Toast
  },

  data() {
    return {
      order: {},
      // payType: 'wxpay'
    };
  },
  mounted() {
    this.init()
  },
  computed: {},
  methods: {
    onClickLeft(){
      //this.$router.go(-1)
       this.$router.push({path: '/home'});
    },
    init() {
      let orderSn = this.$route.query
      this.order =orderSn
    },
      wxPay(){
       Indicator.open({
        text: "支付中...",
        spinnerType: "fading-circle"
       });
      setTimeout(() => {
        Indicator.close();
      }, 60000);
      let that = this;
      let url = `/memberBusiness/goodsPay/${that.order.orderId}/wx`;
      that.$axios.post(url).then(res => {
        if(res.code === 200){
           Indicator.close();
          let data_res = res.data;
          WeixinJSBridge.invoke(
          "getBrandWCPayRequest", {
               "appId":data_res.appId,     //公众号名称，由商户传入
                "paySign":data_res.paySign, //微信签名
                "timeStamp":data_res.timeStamp, //时间戳，自1970年以来的秒数
                "nonceStr":data_res.nonceStr, //随机串
                "package":data_res.packAge, //预支付交易会话标识
                "signType":data_res.signType     //微信签名方式
          },
          function(res) {
            //支付状态回调，res.err_code NaN则成功，-1失败 }
            if (res.err_msg === "get_brand_wcpay_request:ok") {
             // that.showPaying = false; //关闭支付中
             //  this.$router.push({name:'/callback',query: {orderCode:this.order.orderCode}})
             // alert(0);
             
              this.$router.push('/paymentStatus?orderCode='+this.order.orderId)
              //alert(1);
           
            }
          });
        }else{

           // this.closeLoading(res.msg);
             Toast(res.message);
              Indicator.close();
        }
      })
      .catch(err => {
         // this.closeLoading(err.message);
         Toast(err.message);
          Indicator.close();
      });
    },
  

  }
};

</script>

<style lang="less">
    .red {
        color: red;
    }

    .strong {
        font-weight: bold;
    }

    .van-cell-group {
        margin-top: 10px;
    }

    .footer {
        position: fixed;
        bottom: 0px;
    }
</style>
